export default __webpack_public_path__ + "static/media/smartMirror5.16b76c45.jpg";